import { Container } from '@pixi/react'
import { gameConfig } from '../config'
import { useEffect, useRef } from 'react'
import { Container as PixiContainer } from 'pixi.js'
import { freeGameService } from '../domain/freeGame/service/freeGameService'

export const FreeGameScene = () => {
  const sceneRef = useRef<PixiContainer>()

  useEffect(() => {
    freeGameService.sceneContainer = sceneRef.current as PixiContainer
  }, [])

  return (
    <Container
      name="freeGameScene"
      eventMode="static"
      ref={(el: PixiContainer | null) => {
        sceneRef.current = el as PixiContainer
      }}

    >
      <Container
        name="spineContainer"
        eventMode="static"
      />

      <Container
        name="tabAnywhere"
        eventMode="none"
        cursor="pointer"
        anchor={0.5}
        x={gameConfig.resolution.width / 2}
        y={gameConfig.resolution.height - 200}
      />

      <Container
        name="totalWin"
        eventMode="none"
        cursor="pointer"
        x={gameConfig.resolution.width / 2}
        y={750}
      />
    </Container>
  )
}
